import AllBlogs from "../../Components/AllBlogs/AllBlogs";
import TrendingBlogs from "./TrendingBlogs/TrendingBlogs";
import styles from "./Blogs.module.css";

function Blogs() {
  return (
    <div className={styles.blogsContainer}>
      <TrendingBlogs />
      <AllBlogs />
    </div>
  );
}

export default Blogs;
